// Client.vue stays mounted while the user moves between one client's pages, so
// it refetches the client only when something may have changed it. Any write
// might, except these user-scoped ones.
const USER_SCOPED = /^\/(me|login|logout|account)(\/|\?|$)/

let stale = false

export function noteWrite(url) {
    if (!USER_SCOPED.test(url || '')) {
        stale = true
    }
}

export function clientIsStale() {
    return stale
}

export function markClientFresh() {
    stale = false
}
